import classNames from 'classnames'
import React, { useRef, useState } from 'react'
import { getCurrentDateISO, getFutureDateISO, hasDateAlreadyPassed } from '../utils/date'
import s from './DatePicker.less'

// webpack:BrowserOnly
const DatePicker = props => {
  const inputRef = useRef(null)
  const todayDate = getCurrentDateISO()
  const {
    name,
    value = '',
    min = todayDate,
    max = getFutureDateISO({ days: 365 }),
    label,
    className,
    onChange,
    ariaLabel
  } = props

  const [shouldDisplayLabel, setShouldDisplayLabel] = useState(true)

  const onDateChange = () => {
    if (onChange) {
      if (hasDateAlreadyPassed(inputRef.current.value)) onChange(todayDate)
      else onChange(inputRef.current.value)
    }
  }

  const onFocus = e => {
    setShouldDisplayLabel(false)
  }

  const onBlur = e => {
    if (e.target.value === '') setShouldDisplayLabel(true)
  }

  const classnames = classNames(s.dateInput, className)

  const getLabelValue = () => {
    if (value === '' && shouldDisplayLabel) return label
    return ''
  }

  return (
    <div className={s.dateContainer}>
      <span aria-label={label} className={s.label}>
        {getLabelValue()}
      </span>
      <input
        ref={inputRef}
        type="date"
        name={name}
        className={classnames}
        required
        min={min}
        max={max}
        value={value}
        onChange={onDateChange}
        onFocus={onFocus}
        onBlur={onBlur}
        aria-label={ariaLabel}
      />
    </div>
  )
}

export default DatePicker
